import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("close-button__button-33phjw", {
  color: "var(--system-grey-300)",
  position: "absolute",
  width: "32px",
  height: "32px",
  zIndex: 30,
  "&:focus:not(:focus-visible)": {
    outline: "none"
  }
});
import React from 'react';
import { colors } from '../colors';
const CloseButton = (props: Omit<HtmlPropsNoRef<HTMLButtonElement>, 'children'>): JSX.Element => <button {..._mergeProps(props, {
  type: "button",
  "aria-label": "Close",
  css: _staticStyles
})}>
        <div className="close-button__div-0x2b95" />
        <div className="close-button__div-3jb48s" />
    </button>;
export default CloseButton;